import type { FaireProductEntity } from "../../entity_types/product";

export const p_1y88rrps: FaireProductEntity = {
  token: "p_1y88rrps",
  type: "product",
  name: "Amber & Moss - 3.5 oz Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/dbd15873cf1c2ff4b9f7dee5d6983af945be4f6c89999d4dd04cd9389dfe3c11.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/02aac7bf50c5f1727ba6606fb34bff6229e5919f444bdf978b649ffa4ec32029.jpeg",
    "https://cdn.faire.com/fastly/d3fe487ae210d2bb5bfcdd414f7533265078500402824aa0175cedf026760ec3.jpeg",
    "https://cdn.faire.com/fastly/3e5c4ce947afaa2f2a13a2ff4104969a32637e494f8f161f48c259c5b44dce62.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/3ec3b40ddf2d4f1d916cabf565664c386c5376775b70151546c6ca3cbe6a81fc.jpeg",
    "https://cdn.faire.com/fastly/3b84c7448c1fd4ba405db55ed07ec4e0f06691eb41a63bb53f5e1efcda2c2e1c.jpeg",
  ],
  priceDollars: 14.5,
  description:
    'A weekend in the mountains, sun gleaming through the canopy. Sage, moss, and lavender.\n\nLow-maintenance, flame-free, and always-on scent for entry ways, bathrooms, dorm rooms, and bedrooms.\n\nEach diffuser contains a 3.5 fl oz blend of naturally-derived and man-made fragrance oils in a 4 oz amber apothecary-inspired bottle. Includes a bundle of 9" long naturally-harvested rattan reeds to absorb and slowly release the fragrance. \n\nLasts approximately 3-4 months, flip reeds weekly.\n',
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:54.944Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
